import React, { useState } from "react";
import "./css/Register.css";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import ToHomeBtn from "../Shared/ToHomepageBtn";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function Register() {
    const [registerForm, setRegisterForm] = useState({
        email: '',
        password: '',
        confirmPassword: '',
        firstName: '',
        lastName: '',
        phoneNumber: ''
    });
    const navigate = useNavigate();
    const location = useLocation();
    const fromUnderConstruction = location.state?.fromUnderConstruction; 

    const handleRegisterSubmit = async (event) => {
        event.preventDefault();
        if (registerForm.password !== registerForm.confirmPassword) {
            toast.error("Lösenord matchar inte", {
                position: "top-right", autoClose: 3000
            })
            return;
        }
        try {
            //register new user to Supabase auth
            const { data: authData, error: authError } = await supabase.auth.signUp({
                email: registerForm.email,
                password: registerForm.password,
            });
            if (authError) {
                toast.error("Registering misslyckas, prova igen inom kort", {
                    position: "top-right", autoClose: 3000
                })
                console.error("Auth Error:", authError.message, authError.details);
                return;
            }
            //continue registering the new user to Supabase database
            const { data: userData, error: userError } = await supabase.from("users").insert([
                {
                    id: authData.user.id,
                    email: authData.user.email,
                    name: registerForm.firstName + " " + registerForm.lastName,
                    phone_number: registerForm.phoneNumber,
                },
            ])
            .select();

            const getIpAddess = async () => {
                try {
                    const response =  await fetch('https://api64.ipify.org?format=json');
                    if (response.ok){
                        const data = await response.json()
                        return data.ip;
                    } else {
                        return null;
                    }
                } catch (e){
                    console.error("cant get them ip, here's why: " + e)
                    return null;
                }
            }
            console.log("ini nih yang register :" + authData.user.id)
            const ipAddress = await getIpAddess() || "unknown address";
            const { data: timeStamp, error: timeStampError } = await supabase
                .from("user_activity")
                .insert([
                    {
                        user_id: authData.user.id,
                        activity_type: 'registration',
                        timestamp: new Date().toISOString(),
                        device: 'Web',
                        ip_address: ipAddress
                    }
                ]);

            if (timeStamp) {
                console.log("Yay")
            } else if (timeStampError) {
                console.error("Error logging activity:", timeStampError);
            }

            if (userError) {
                console.error("Insert Error:", userError.message, userError.details);
                toast.error("Försäkra att du har inte registrerat det här kontot förrut", {
                    position: "top-right", autoClose: 3000
                })
                return;
            }
            //success
            toast.success("Nu är du registrerat! Välkommen " + authData.user.email, {
                position: "top-right", autoClose: 3000
            })
            setRegisterForm({ email: '', password: '', confirmPassword: '', firstName: '', lastName: '', phoneNumber: '' })
               if (fromUnderConstruction) {
                setTimeout(() => navigate("/under-construction"), 1000);
            }else{
                setTimeout(() => navigate("/webshop"), 1000);
            }
        } catch (error) {
            console.error("Unexpected Error:", error.message);
            alert(`An unexpected error occurred: ${error.message}`);
        }
    };

    return (
        <div className="register-container">
            <div className="register-background-image"></div>
            <ToastContainer />
            {!fromUnderConstruction && <ToHomeBtn />}
            <div className="register-card">
                <h2 className="register-heading">Skapa konto</h2>
                <form onSubmit={handleRegisterSubmit} className="register-form">
                    <div className="form-group">
                        <label htmlFor="firstName" className="form-label">
                            Förnamn:
                        </label>
                        <input onChange={(e) => setRegisterForm(prev => ({ ...prev, firstName: e.target.value }))} id="firstName" type="text" name="firstName" placeholder="Fyll i förnamn" required className="form-input" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="lastName" className="form-label">
                            Efternamn:
                        </label>
                        <input onChange={(e) => setRegisterForm(prev => ({ ...prev, lastName: e.target.value }))} id="lastName" type="text" name="lastName" placeholder="Fyll i efternamn" required className="form-input" />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email" className="form-label">
                            E-postadress:
                        </label>
                        <input onChange={(e) => setRegisterForm(prev => ({ ...prev, email: e.target.value }))} id="email" type="email" name="email" placeholder="Fyll i e-postadress" required className="form-input" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="phoneNumber" className="form-label">
                            Mobilnummer:
                        </label>
                        <input onChange={(e) => setRegisterForm(prev => ({ ...prev, phoneNumber: e.target.value }))} id="phoneNumber" type="tel" name="phoneNumber" placeholder="Fyll i mobilnummer" required className="form-input" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password" className="form-label">
                            Lösenord:
                        </label>
                        <input onChange={(e) => setRegisterForm(prev => ({ ...prev, password: e.target.value }))} id="password" type="password" name="password" placeholder="Fyll i lösenord" required className="form-input" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="confirmPassword" className="form-label">
                            Bekräfta Lösenord:
                        </label>
                        <input
                            onChange={(e) => setRegisterForm(prev => ({ ...prev, confirmPassword: e.target.value }))}
                            id="confirmPassword"
                            type="password"
                            name="confirmPassword"
                            placeholder="Bekräfta lösenord"
                            required
                            className="form-input"
                        />
                    </div>

                    <button type="submit" onClick={handleRegisterSubmit} className="register-button">
                        Registrera
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Register;
